import global from "@/locales/fi-FI/global";
import error403 from "@/locales/fi-FI/errors/403";
import error404 from "@/locales/fi-FI/errors/404";
import error500 from "@/locales/fi-FI/errors/500";
import error503 from "@/locales/fi-FI/errors/503";
import error504 from "@/locales/fi-FI/errors/504";
import maintenance from "@/locales/fi-FI/auth/maintenance";
import toast from "@/locales/fi-FI/toast/toast";
import login from "@/locales/fi-FI/auth/login";
import onboarding from "@/locales/fi-FI/auth/onboarding";
import loginPageSteps from "@/locales/fi-FI/loginPageSteps";
import dashboard from "@/locales/fi-FI/dashboard/dashboard";
import account from "@/locales/fi-FI/account/account";
import mailbox from "@/locales/fi-FI/account/mailbox";
import bankstatement from "@/locales/fi-FI/account/bankstatement";
import myApps from "@/locales/fi-FI/my-apps/myApps";
import about from "@/locales/fi-FI/about/about";
import contactService from "@/locales/fi-FI/about/contactService";
import salesPromotions from "@/locales/fi-FI/sales/promotions";
import brochures from "@/locales/fi-FI/sales/brochures";
import shop from "@/locales/fi-FI/shop/data";
import priceList from "@/locales/fi-FI/shop/priceList";
import staff from "@/locales/fi-FI/dashboard/staff";
import promotions from "@/locales/fi-FI/promotions";
import points from "@/locales/fi-FI/points";
import trainings from "@/locales/fi-FI/trainings/trainings";
import vouchers from "@/locales/fi-FI/vouchers/vouchers";
import media from "@/locales/fi-FI/media/index";
import product from "@/locales/fi-FI/product/index";
import message from "@/locales/fi-FI/message/index";
import commitmentLetter from "@/locales/fi-FI/account/commitmentLetter";
import multiplicator from "@/locales/fi-FI/multiplicator";
import widgets from "@/locales/fi-FI/widgets/widgets";
import consents from "@/locales/fi-FI/consents/consents";
import investment from "@/locales/fi-FI/investment/data";
import kickback from "@/locales/fi-FI/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Tuotekuvat",
    BDriveLinkText: "Linkki TUOTEKUVIEN portaaliin",
  },
}

export default {
  locale: "fi-FI",
  messages,
};
